<template>
  <div class="headerContain">
    <div class="headerTop">
      <div class="headerLine layout text_center">
        <div class="headerLeft text_center">
          <logo/>
          <ul class="headerTip text_center pointer">

              <router-link to="/workflow/index" tag="li" >首页</router-link>

              <li @click="toServiceC(true)" :class="routeName() == 'serviceC' && 'active'">服务中心</li>
             <!-- <router-link to="/workflow/serviceCenter" tag="li" </router-link> -->
            <router-link
                v-if="userName"
                tag="li"
                to="/workflow/todo"
                :class="(
                    routeName() == 'todo'
                 || routeName() == 'doing'
                 || routeName() == 'flow_cc'
                 || routeName()== 'done')?'active':''"
            >个人中心
            </router-link>
<!--            <li @click="pushTJ">事项统计</li>-->
            <router-link 
            v-if="userName"
            to="/workflow/favorite" tag="li">我的收藏</router-link>

<!--            <router-link to="/workflow/helpcenter" tag="li">帮助中心</router-link>-->
          </ul>
        </div>
        <div class="headerRight text_center font_s_14">
          <template v-if="!userName">
            <span class="pointer" @click="toServiceC(false)">
            <img src="@/assets/images/new/eye.svg" alt="" style="width: 16px;height:16px;">
            访客浏览
          </span>
          &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
          <span class="pointer" @click="toLogin">
            去登录
          </span>

          </template>
          


          <el-dropdown v-else @command="handleCommand" size="small">
          <!-- <span >{{ userName }}<br/> -->
            <!-- <span class="pointer" @click="signOutOidc">退出</span></span> -->

  <span class="el-dropdown-link">
    <i class="el-icon-user"></i>{{userName}}
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item command="out">退出登录</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
        </div>
      </div>
    </div>
    <CommonBanner @searchText="searchText"/>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import CommonBanner from "./commonBanner";
import gql from "graphql-tag";
export default {
  name: 'commonHeader',
  inject: ['routeName'],
  components: {CommonBanner},
  computed: {
    userName() {
      return this.$store.getters.getUserInfo.name;
    }
  },
  methods: {
    ...mapActions("oidcStore", ['signOutOidc']),
    toServiceC(bool) {
      sessionStorage.setItem('hasSigned', bool);
      this.$router.push({'name': 'serviceC'})
    },
    signIn() {
      this.$router.push('/workflow/home');
    },
    toLogin() {
      console.log(this.$store.getters.getAuth.access_token)
      if (!this.$store.getters.getAuth.access_token){
        sessionStorage.setItem('hasSigned', true)
      }
      // console.log()
      this.$router.push({path:'/workflow/home'})
    },
    searchText(val) {
      this.$emit('searchFun', val);

    },
    handleCommand() {
      sessionStorage.removeItem('hasSigned')
      this.signOutOidc()
    },
    pushTJ() {
      window.open('https://lc.squ.edu.cn/infoplus-analysis/index');
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/commonHeader.vue